import useTranslation from "next-translate/useTranslation";
import dynamic from "next/dynamic";
import React, { useState } from "react";
import { isValidPhoneNumber } from "react-phone-number-input";
import { useSelector } from "react-redux";
import PROXY_CONFIG from "../../../Config/ProxyConfig";
import styles from "../contact.module.css";
import api_call_v2 from "utils/API_CALL/api_call_v2";

const PhoneInputComponent = dynamic(
  () => import("./../../../utils/PhoneInput/PhoneInput"),
  {
    ssr: false,
  }
);

const contactForm = () => {
  const { t } = useTranslation("contact");
  const userRedux = useSelector((store) => store?.auth?.user);

  const selectInfos = [
    "Agent immobilier",
    "Banques et assurances",
    "Notaire",
    "Promoteur / Constructeur",
    "Gestionnaire de patrimoine",
    "Syndic",
    "Expert",
  ];
  const [infos, setInfos] = useState({
    fullName: userRedux
      ? `${userRedux.firstName ? userRedux.firstName : ""}${
          userRedux.firstname ? userRedux.firstname : ""
        } ${userRedux.lastName ? userRedux.lastName : ""}${
          userRedux.lastname ? userRedux.lastname : ""
        }`
      : "",
    fonction: "Choisir",
    email: userRedux ? userRedux.email : "",
    phone: userRedux ? userRedux.phone : "",
    message: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [errorForm, setErrorForm] = useState({});
  const formValidation = () => {
    const errors = {};
    const regex =
      /^([a-zA-Z._0-9-]+)@([a-zA-Z0-9]+[.]?)*([a-zA-Z0-9])(\.[a-zA-Z]{2,4})$/i;
    if (!infos.fullName) {
      errors.fullName = t("Le nom est requis");
    } else if (Object.keys(infos.fullName).length < 5) {
      errors.fullName = t("Le nom doit contenir au moins 5 caractères");
    }
    if (infos.fonction === "Choisir") {
      errors.fonction = t("Le champ fonction est requis");
    }
    if (!infos.email) {
      errors.email = t("Email requis");
    } else if (!regex.test(infos.email)) {
      errors.email = t("Adresse mail invalide");
    }
    if (!infos.phone) {
      errors.phone = t("Le numéro de téléphone est requis");
    }
    if (!isValidPhoneNumber(infos.phone)) {
      errors.phoneFormat = t("Format incorrect");
    }
    if (!infos.message) {
      errors.message = t("Ce champs est requis");
    } else if (Object.keys(infos.message).length < 20) {
      errors.message = t("Votre message doit contenir au moins 20 caractères");
    }
    if (Object.keys(errors).length === 0) {
      return false;
    }
    // else
    //   setErrorForm(errors)
    return errors;
  };
  const [messageSent, setMessageSent] = useState(false);
  const [messageSentError, setMessageSentError] = useState(false);
  const send_to_back = () => {
      api_call_v2(
        undefined,
        "post",
        "addContactMessage",
        {
          data: {
            user_id: userRedux ? (userRedux._id ? userRedux._id : "") : "",
            email: infos.email,
            job: infos.fonction,
            message: infos.message,
            name: infos.fullName,
            phone: infos.phone,
          },
        },
      )
      .then((res) => {
        setIsLoading(false);
        setMessageSent(true);
        setMessageSentError(false);
      })
      .catch((err) => {
        this.props.contactSendError();
        setIsLoading(false);
        setMessageSent(false);
        setMessageSentError(false);
      });
  };
  const submitInfos = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const err = formValidation();
    if (err) {
      setIsLoading(false);
      setErrorForm(err);
    } else {
      setErrorForm({});
      send_to_back();
    }
  };

  return (
    <div className={styles.form_container}>
      <form
        className={styles.contact_form}
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <div className={styles.form_element_containers}>
          <label className={styles.form_input_title}>
            {t("Nom et prénom")}
          </label>
          <input
            type="text"
            className={styles.input_form}
            placeholder={t("Nom et prénom")}
            value={infos.fullName}
            onChange={(e) => setInfos({ ...infos, fullName: e.target.value })}
          />
          <p className={styles.error_format}>{errorForm.fullName}</p>
        </div>
        <div className={styles.form_element_containers}>
          <label className={styles.form_input_title}>{t("Fonction")}</label>
          <div className={styles.select_container}>
            <select
              className={styles.select_choices}
              value={t(infos.fonction)}
              onChange={(e) => {
                setInfos({ ...infos, fonction: e.target.value });
                e.target.style.color = "black";
              }}
            >
              <option disabled value={t("Choisir")}>
                {"--"} {t("Choisir")} {"--"}
              </option>
              {selectInfos.map((item2, mid) => {
                return (
                  <option
                    key={mid}
                    className={styles.choice_rating_phrase}
                    value={item2}
                  >
                    {t(`${item2}`)}
                  </option>
                );
              })}
            </select>
            <div className={styles.svg_container}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11"
                height="18"
                viewBox="0 0 11 18"
                fill="none"
              >
                <g clipPath="url(#clip0_7316_6999)">
                  <path
                    d="M4.72504 12.9373C5.15473 13.3523 5.85254 13.3523 6.28223 12.9373L10.6822 8.68731C10.9985 8.38184 11.0913 7.92695 10.9194 7.52852C10.7475 7.13008 10.3488 6.87109 9.90191 6.87109L1.10191 6.87441C0.658476 6.87441 0.256289 7.1334 0.0844136 7.53184C-0.0874614 7.93027 0.00878864 8.38516 0.321601 8.69063L4.7216 12.9406L4.72504 12.9373Z"
                    fill="black"
                    fillOpacity="0.8"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_7316_6999">
                    <rect
                      width="11"
                      height="17"
                      fill="white"
                      transform="translate(0 0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <p className={styles.error_format}>{errorForm.fonction}</p>
        </div>
        <div className={styles.form_element_containers}>
          <label className={styles.form_input_title}>
            {t("Adresse email")}
          </label>
          <input
            type="text"
            className={styles.input_form}
            placeholder={t("Adresse email")}
            value={infos.email}
            onChange={(e) => setInfos({ ...infos, email: e.target.value })}
          />
          <p className={styles.error_format}>{errorForm.email}</p>
        </div>
        <div className={styles.form_element_containers}>
          <label className={styles.form_input_title}>
            {t("Numéro de téléphone")}
          </label>
          <PhoneInputComponent
            className={`${styles.input__phone} ${
              errorForm.phone ? styles.input_error_phone : ""
            } `}
            autoFormat={false}
            displayLabel={false}
            name="phoneNumber"
            id={
              errorForm.phone || errorForm.phoneFormat
                ? "telephoneError"
                : "telephone"
            }
            data-cy="user-phone"
            variant="outlined"
            defaultCountry={"MA"}
            countries={["MA", "TN", "FR"]}
            value={infos.phone}
            error={errorForm.phone ? errorForm.phone : errorForm.phoneFormat}
            onChange={(e) => {
              setInfos({ ...infos, phone: e ? e : "" });
              setErrorForm({
                ...errorForm,
                phone: e === undefined ? "Champ requis" : "",
              });
              setErrorForm({
                ...errorForm,
                phoneFormat: !isValidPhoneNumber(e ? e : "")
                  ? "Format incorrect"
                  : "",
              });
            }}
            helperText={
              errorForm.phone
                ? t("Champs requis")
                : errorForm.phoneFormat
                ? t("Format incorrect")
                : ""
            }
            errorPhone={errorForm.phone || errorForm.phoneFormat}
            t={t}
          />

          {/* <p className={styles.error_format}>{errorForm.phone}</p> */}
        </div>
        <div className={styles.form_element_containers}>
          <label className={styles.form_input_title}>{t("Message")}</label>
          <textarea
            type="text"
            className={styles.text_area}
            placeholder={t("Message")}
            value={infos.message}
            onChange={(e) => setInfos({ ...infos, message: e.target.value })}
          />
          <p className={styles.error_format}>{errorForm.message}</p>
        </div>
        <button onClick={submitInfos} className={styles.button_indigo}>
          {!isLoading ? (
            t("Envoyer")
          ) : (
            <i className="fas fa-circle-notch fa-spin"></i>
          )}
        </button>
        {messageSent && (
          <p className={styles.message_success}>
            {t(
              "Message envoyé avec succès, nous vous répondrons dans les plus brefs délais"
            )}{" "}
          </p>
        )}
        {messageSentError && (
          <p className={styles.message_error}>
            {t("Impossible d'envoyer le message, veuiller réessayer plus tard")}
          </p>
        )}
      </form>
    </div>
  );
};

export default contactForm;
